export const Z_INDEX = {
  header: 3,
  navBar: 2,
  modal: 1,
}